import { type IDirectRenderer } from './renderer/direct-renderer'
import { type WithIFrame, type EmbedStrategy } from '../embed-strategy'
import { type ExperienceActivationPayload } from '../../../types/models'
import { VueDirectRenderer } from './renderer/vue/vue-direct-renderer'
import { type EmbedTarget } from '../..'
import { DefaultIFrameEmbedComponent, type EmbedIFrameComponent } from '../../embed-component'
import { IFrameExperienceAdapter } from './experience-adapter/iframe/iframe-experience-adapter'
import { type IExperienceAdapter } from './experience-adapter/experience-adapter'

export class DirectEmbedStrategy implements EmbedStrategy, WithIFrame {
  renderer: IDirectRenderer
  target: EmbedTarget
  iexAdapter: IExperienceAdapter
  iFrameComponent: EmbedIFrameComponent

  constructor (target: EmbedTarget) {
    this.target = target
    this.iFrameComponent = new DefaultIFrameEmbedComponent(this.target.ctx.url, this.target.ctx)
    this.iexAdapter = new IFrameExperienceAdapter(this.target, this.iFrameComponent, () => this.renderer.currentActivations)
    this.renderer = new VueDirectRenderer(this.target.ctx, this.iexAdapter.analytics())
  }

  async embed (): Promise<void> {
    await this.iexAdapter
      .onCurrentActivationsUpdate((items: ExperienceActivationPayload[]) => {
        this.renderer.setCurrentActivations(items)
      })
      .onReady(async () => {
        await this.renderer.initialize()
      })
      .initialize()
  }

  show (): void {
    this.renderer.show()
  }

  hide (): void {
    this.renderer.hide()
  }
}
